import {useContext, useEffect, useState} from "react";
import {ModalContext} from "../../../utils/modal/ModalProvider";
import styles from "../../../utils/modal/DetailModal.module.css";
import {IAM_SERVER_UNIFIEDPROFILE} from "../../../utils/Config";
import axios from "../../../utils/api/axios";
import {DialogEnum, showDialog} from "../../../utils/dialog/Dialog";
import Loading from "../../../utils/loading/Loading";
import { ServiceListContainer} from "./ServiceListContainer";


/**
 * 사용자 상세정보 모달 Container
 * @param id
 * @param update
 * @returns {JSX.Element}
 * @constructor
 */
export const IdentityDetailModal = ({id, update, isMobileWindow}) => {

    const {closeModal} = useContext(ModalContext);

    const [loading, setLoading] = useState(true);

    const [formData, setFormData] = useState({
        unifiedProfileId: '',
        name: '',
        phoneNumber: '',
        birth: '',
        gender: '',
        postNumber: '',
        address: '',
        addressDetail: '',
    });

    const [formServiceData, setFormServiceData] = useState({
        service_name: '',
        created_date: '',
        last_date: '',
        status: '',
    });

    const [detailList, setDetailList] = useState([]);

    useEffect(() => {
        // id로 사용자 정보 조회
        const url = IAM_SERVER_UNIFIEDPROFILE + "/get/" + id;
        axios.get(url)
            .then((res) => {
                setFormData({
                    unifiedProfileId: res.data.data.unifiedProfileId,
                    name: res.data.data.name,
                    phoneNumber: res.data.data.contactInfo,
                    birth: res.data.data.birth,
                    gender: res.data.data.gender,
                    postNumber: res.data.data.postNumber,
                    address: res.data.data.address,
                    addressDetail: res.data.data.addressDetail
                });


                //id로 사용자 service 조회 필요 token으로
                const userServiceUrl = IAM_SERVER_UNIFIEDPROFILE + "/get/" + id +"/service";
                axios.get(userServiceUrl)
                    .then((serviceRes) => {

                        setDetailList(serviceRes.data.data);
                    })
                    .catch((e) => {
                        showDialog(DialogEnum.DEFAULT, "실패", "사용자 정보 조회에 실패했습니다.");
                    })
            })
            .catch((e) => {
                showDialog(DialogEnum.DEFAULT, "실패", "사용자 정보 조회에 실패했습니다.");
            })
            .finally(() => {
                setLoading(false);
            })

           

    }, []);

    const handleChange = (e) => {
        const {name, value} = e.target;
        setFormData((prevState) => ({
            ...prevState,
            [name]: value
        }));
    }

    const handleSwitch = () => {
        if (formData.alarm === 'Y') {
            setFormData({
                ...formData, alarm: 'N'
            });
        } else {
            setFormData({
                ...formData, alarm: 'Y'
            });
        }
    }

    // 사용자 상세정보 수정 요청 API
    const handleModify = () => {
        // if (checked) {
        //     if (formData.password !== formData.passwordConfirm) {
        //         showDialog(DialogEnum.DEFAULT, "경고", "비밀번호를 확인해주세요.");
        //         return;
        //     }
        // }
        const url = IAM_SERVER_UNIFIEDPROFILE + "/update";
        const params = Object.assign({}, formData);
        delete params.passwordConfirm;
        axios.post(url, params)
            .then((res) => {
                showDialog(DialogEnum.SUCCESS, "성공", res.data.message, closeModal);
                update();
            })
            .catch((e) => {
                showDialog(DialogEnum.DEFAULT, "실패", e.response.data.resultMessage);
            })
    }

    
    const handleCancle = () => {
        closeModal();
    }

    return (
        <div style={{overflow: "auto"}}>
            {loading ? <Loading/> :
                <div>
                    <ul className={styles.layer__listWrap}>
                        <li className={styles.layer__list}>
                            <p className={styles.layer__listTit}>아이디</p>
                            <input className={styles.layer__listInput}
                                   type={"text"}
                                   name={"id"}
                                   value={formData.unifiedProfileId}
                                   readOnly={true}/>
                        </li>

                        <li className={styles.layer__list}>
                            <p className={styles.layer__listTit}>이름</p>
                            <input className={styles.layer__listInput}
                                   type={"text"}
                                   name={"name"}
                                   value={formData.name}
                                   readOnly={true}
                                   onChange={handleChange}/>
                        </li>

                        <li className={styles.layer__list}>
                            <p className={styles.layer__listTit}>전화번호</p>
                            <input className={styles.layer__listInput}
                                   type={"text"}
                                   name={"phoneNumber"}
                                   value={formData.phoneNumber}
                                   readOnly={true}
                                   onChange={handleChange}/>
                        </li>

                        <li className={styles.layer__list}>
                            <p className={styles.layer__listTit}>생년월일</p>
                            <input className={styles.layer__listInput}
                                   type={"text"}
                                   name={"birth"}
                                   value={formData.birth}
                                   readOnly={true}
                                   onChange={handleChange}/>
                        </li>


                        <li className={styles.layer__list}>
                            <p className={styles.layer__listTit}>성별</p>
                            <div className={styles.layer__radioGroup}>
                                <label>
                                    <input
                                        type="radio"
                                        name="gender"
                                        value="man"
                                        // ✅ formData.gender가 "man"일 때만 checked
                                        checked={formData.gender === "man"}
                                        // ✅ readOnly 대신 disabled 사용
                                        disabled={true} 
                                        // disabled 상태에서는 onChange가 호출되지 않으므로 제거해도 무방합니다.
                                        // onChange={handleChange} 
                                    />
                                    남
                                </label>
                                <label style={{marginLeft: '20px'}}>
                                    <input
                                        type="radio"
                                        name="gender"
                                        value="woman"
                                        // ✅ formData.gender가 "woman"일 때만 checked
                                        checked={formData.gender === "woman"}
                                        // ✅ readOnly 대신 disabled 사용
                                        disabled={true}
                                        // onChange={handleChange}
                                    />
                                    여
                                </label>
                            </div>
                        </li>

                        <li className={styles.layer__list}>
                            <p className={styles.layer__listTit}>우편번호</p>
                            <input className={styles.layer__listInput}
                                   type={"text"}
                                   name={"postNumber"}
                                   value={formData.postNumber}
                                   onChange={handleChange}/>
                        </li>

                        <li className={styles.layer__list}>
                            <p className={styles.layer__listTit}>주소</p>
                            <input className={styles.layer__listInput}
                                   type={"text"}
                                   name={"address"}
                                   value={formData.address}
                                   onChange={handleChange}/>
                        </li>

                        <li className={styles.layer__list}>
                            <p className={styles.layer__listTit}>상세주소</p>
                            <input className={styles.layer__listInput}
                                   type={"text"}
                                   name={"addressDetail"}
                                   value={formData.addressDetail}
                                   onChange={handleChange}/>
                        </li>
                    </ul>            

                    <ServiceListContainer id={id} detailList={detailList} update={update} isMobileWindow={isMobileWindow}/>

                    <div className={styles.layer__sensorBtnBox}>
                        <button className={styles.layer__cancleBtn} onClick={handleCancle}>취소</button>
                        <button className={styles.layer__modifyBtn} onClick={handleModify}>수정</button>                        
                    </div>
                </div>
            }
        </div>
    );
}